import { render, staticRenderFns } from "./StudentByEthnicity.vue?vue&type=template&id=4e6b830b&scoped=true&"
import script from "./StudentByEthnicity.vue?vue&type=script&lang=js&"
export * from "./StudentByEthnicity.vue?vue&type=script&lang=js&"
import style0 from "./StudentByEthnicity.vue?vue&type=style&index=0&id=4e6b830b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b830b",
  null
  
)

export default component.exports